import { isEmpty } from '../../utils/helper';
import { EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';

/**
 * @description Function to manipulate todo objects as  per the component
 * @param {Array} todos
 * @returns {Array} returns array of manipulated objects needed for the component
 */
export const getManipulatedTodosForComponent = todos => {
  if (isEmpty(todos)) {
    return EMPTY_ARRAY;
  }
  const manipulatedTodos = [];
  todos.forEach(todo => {
    const {
      id,
      title,
      color
    } = todo;
    const manipulatedTodo = {
      id,
      event_type: todo.event_type,
      title,
      color,
      todoList: todo.todo_items.map(todoItem => ({
        id: todoItem.id,
        checked: todoItem.checked,
        item: todoItem.body
      })),
      created_at: todo.created_at
    };
    manipulatedTodos.push(manipulatedTodo);
  });
  return manipulatedTodos.sort((a, b) => b.created_at - a.created_at);
};

/**
 * @description Function to manipulate todo objects as needed for Api
 * @param {Object} todo
 * @returns {Object} returns todo object that needed for Api
 */
export const getManipulatedTodosForApi = (todo, idKey, itemIdKey) => {
  if (isEmpty(todo)) {
    return EMPTY_OBJECT;
  }
  const {
    id,
    title,
    color
  } = todo;
  const manipulatedTodo = {
    [idKey]: id,
    event_type: 'todo',
    title,
    color,
    todo_items: todo.todoList.map(todoItem => ({
      [itemIdKey]: todoItem[itemIdKey].startsWith('new') ? EMPTY_STRING : todoItem[itemIdKey],
      checked: todoItem.checked,
      body: todoItem.item
    })),
    created_at: todo.created_at
  };
  return manipulatedTodo;
};